import { Component } from '@angular/core';
import { Loader } from '../../../../shared/components/loader/loader';
import { UpperCasePipe } from '../../../../shared/pipes/upper-case-pipe';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { CustomPaginationComponent } from '../../../../shared/components/custom-pagination/custom-pagination.component';
import { NoDataComponent } from '../../../../shared/components/no-data/no-data.component';
import { SharedModal, ModalConfig } from '../../../../shared/components/shared-modal/shared-modal';
import { segment_endpoint } from '../../../data/api-endpoint/segment-endpoint';
import { ContentMapperService } from '../../../core/services/content-mapper-service';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from '../../../core/services/common.service';
import { FilterSharedDropdown } from '../../../../shared/components/filter-shared-dropdown/filter-shared-dropdown';

@Component({
  selector: 'app-segment-permission',
  imports: [Loader, UpperCasePipe, CommonModule, ReactiveFormsModule, FormsModule, CustomPaginationComponent, NoDataComponent, SharedModal, FilterSharedDropdown],
  templateUrl: './segment-permission.html',
  styleUrl: './segment-permission.scss'
})
export class SegmentPermission {
  loader: boolean = false;
  searchIcon = 'assets/img/search.svg';
  filterIcon = 'assets/img/filter.png';
  plusIcon = 'assets/img/plus.svg';
  editIcon = 'assets/img/edit.png';
  deleteIcon = 'assets/img/bin.png';
  upIcon = 'assets/img/up.png';
  downIcon = 'assets/img/down.png';


  sortingKey: string = '';
  sortingValue: string = '';
  debounceTimeout!: any


  toggleFilter: boolean = false;
  activeDropdownIndex: number = -1;

  filter: any = {
    page: 1,
    limit: 10,
    search: '',
    sortKey: '',
    sortValue: '',
    segment_type: [],
    status: [],
    providerElementIds: [],
    partnerIds: [],
  }
  contentPoolStatus: any[] = []


  statusList: Record<string, string>[] = [];
  segmentTypeList: Record<string, string>[] = [];
  partnerList: string[] = [];
  providerElementList: string[] = [];


  approvalSegmentList: any = []
  totalCount: number = 0;

  segmentStatusModalConfig: ModalConfig = {
    isOpen: false,
    type: 'segment-review',
    segmentData: null
  };

  selectedSegment: any = null;

  constructor(private contentMapper: ContentMapperService, private toastr: ToastrService, private commonService: CommonService) {

  }

  ngOnInit(): void {
    this.fetchApprovalList()
    this.fetchFilter()
    document.addEventListener('click', (event) => {
      const target = event.target as HTMLElement;
      if (!target.closest('.action-dropdown')) {
        this.activeDropdownIndex = -1;
      }
    });
  }




  onSearch(e: Event) {
    const value = (e.target as HTMLInputElement).value;
    clearTimeout(this.debounceTimeout);
    this.debounceTimeout = setTimeout(() => {
      this.filter.search = value?.trim();
      this.filter.page = 1;
      this.fetchApprovalList()
    }, 1000);
  }


  openFilter() {
    this.toggleFilter = !this.toggleFilter;
  }

  sorting(key: string) {
    this.sortingKey = key;
    this.sortingValue = !this.sortingValue ? 'ASC' : (this.sortingValue === 'ASC' ? 'DESC' : 'ASC');
    this.filter.sortKey = this.sortingKey;
    this.filter.sortValue = this.sortingValue;
    this.filter.page = 1;
    this.fetchApprovalList()
  }


  fetchUserDataByPage(data: { page: number }) {
    this.filter.page = data.page;
    this.fetchApprovalList();
  }




  fetchApprovalList() {
    this.loader = true;
    const { segment_type, status, page, limit, search, sortKey, sortValue,
      providerElementIds, partnerIds } = this.filter;

    const final_data: any = {
      segmentTypes: segment_type.map((item: any) => item.id),
      statuses: status.map((item: any) => item.id),
      page,
      limit,
      search,
      sortKey,
      sortOrder: sortValue,
      providerElementIds: providerElementIds.map((item: any) => +item.id),
      partnerIds: partnerIds.map((item: any) => item.id)
    };
    this.contentMapper.post(segment_endpoint.permission, final_data).subscribe({
      next: (response: any) => {
        this.loader = false;
        const { segments = [], totalRecords } = response.results
        this.totalCount = totalRecords;
        this.commonService.updateSharedData(totalRecords);
        this.approvalSegmentList = segments;
      }, error: (error) => {
        this.loader = false;
        this.toastr.error(this.checkIsErrorMessageValid(error));
      }
    })
  }

  getStatusChipClass(status: string): string {
    const statusMap: Record<string, string> = {
      'archived': 'archived',
      'active': 'active',
      'inactive': 'inactive',
      'pending': 'pending',
      'deleted': 'deleted',
      'does not exist': 'not-exist',
      'not exist': 'not-exist',
      'does_not_exist': 'not-exist',
      'missing': 'not-exist'
    };

    return statusMap[status?.toLowerCase()] || 'inactive';
  }

  getSegmentTypeChipClass(segmentType: string): string {
    const segmentTypeMap: Record<string, string> = {
      'standard': 'standard',
      'custom': 'custom'
    };

    return segmentTypeMap[segmentType?.toLowerCase()] || 'standard';
  }

  toggleDropdown(index: number): void {
    this.activeDropdownIndex = this.activeDropdownIndex === index ? -1 : index;

  }


  openChangeStatusModal(segment: any): void {
    this.loader = true;
    this.selectedSegment = segment;
    this.commonService.updateShareContentPoolStatus([])
    this.getCurrentSegment(segment.id);
    this.activeDropdownIndex = -1;
  }

  onSegmentStatusConfirm(data: any): void {
    const { status, segmentData } = data;

    if (status === 'activate') {
      this.changeSegmentStatus(segmentData, 'approve');
    } else if (status === 'reject') {
      this.changeSegmentStatus(segmentData, 'rejected');
    }

    this.closeSegmentStatusModal();
  }


  onSegmentStatusCancel(): void {
    this.closeSegmentStatusModal();
  }

  checkIsErrorMessageValid(error: any) {
    if(typeof error?.error?.message === 'string') {
      return error?.error?.message;
    }
    return 'An unknow error occured';
  }


  private closeSegmentStatusModal(): void {
    this.segmentStatusModalConfig = {
      isOpen: false,
      type: 'segment-review',
      segmentData: null
    };
    this.selectedSegment = null;
  }


  private changeSegmentStatus(segment: any, status: string): void {
    this.loader = true;
    const payload = {
      id: segment.id,
      status: status
    };

    this.contentMapper.post(segment_endpoint.changeStatus, payload).subscribe({
      next: (_: any) => {
        this.loader = false;
        this.toastr.success(`Segment "${segment.name}" has been ${status} successfully on The Trade Desk`);
        this.fetchApprovalList();
      },
      error: (error) => {
        this.loader = false;
        this.toastr.error(this.checkIsErrorMessageValid(error), 'Error');
        console.error('Error activating segment:', error);
      }
    });
  }

  clearFilterDropdown(type: string) {
    const action: Record<string, () => void> = {
      'segment_type': () => this.filter.segment_type = [],
      'status': () => this.filter.status = [],
      'providerElementIds': () => this.filter.providerElementIds = [],
      'partnerIds': () => this.filter.partnerIds = [],
    };
    action[type]()
    this.filter.page = 1;
    this.fetchApprovalList();
  }

  selectFilterDrowDownItem(data: { checked: boolean }, type: string) {
    const { checked } = data;
    const action: Record<string, () => void> = {
      'segment_type': () => this.filter = {
        ...this.filter,
        segment_type: checked ? this.segmentTypeList : []
      },
      'status': () => this.filter = {
        ...this.filter,
        status: checked ? structuredClone(this.statusList) : []
      },
      'providerElementIds': () => this.filter = {
        ...this.filter,
        providerElementIds: checked ? structuredClone(this.providerElementList) : []
      },
      'partnerIds': () => this.filter = {
        ...this.filter,
        partnerIds: checked ? structuredClone(this.partnerList) : []
      },
    };
    action[type]();
    this.filter.page = 1;
    this.fetchApprovalList();
  }

  isItemChecked(data: { checked: boolean, item: any }, type: string) {
    const { checked, item } = data;
    const action: Record<string, () => void> = {
      'segment_type': () => checked ? this.filter.segment_type.push(item) : this.filter.segment_type = this.filter.segment_type.filter((child: any) => child.name != item.name),
      'status': () => checked ? this.filter.status.push(item) : this.filter.status = this.filter.status.filter((child: any) => child.name != item.name),
      'providerElementIds': () => checked ? this.filter.providerElementIds.push(item) : this.filter.providerElementIds = this.filter.providerElementIds.filter((child: any) => child.name != item.name),
      'partnerIds': () => checked ? this.filter.partnerIds.push(item) : this.filter.partnerIds = this.filter.partnerIds.filter((child: any) => child.name != item.name),
    };
    action[type]();
    this.filter.page = 1;
    this.fetchApprovalList();
  }

  clearFilter() {
    this.filter = {
      page: 1,
      limit: 10,
      search: '',
      sortKey: '',
      sortValue: '',
      segment_type: [],
      status: [],
      providerElementIds: [],
      partnerIds: []
    };

    this.sortingKey = ''
    this.sortingValue = ''
    this.fetchApprovalList()
  }




  fetchFilter() {
    this.contentMapper.get(segment_endpoint.filter).subscribe({
      next: (response: any) => {
        const { statuses = [], segmentTypes = [], providerElementIds = [], partnerIds = [] } = response.results
        this.statusList = statuses;
        this.segmentTypeList = segmentTypes;
        this.providerElementList = providerElementIds.map((item: any) => {
          return {
            name: item,
            id: item
          }
        });


        this.partnerList = partnerIds.map((item: any) => {
          return {
            name: item,
            id: item
          }
        });

      }, error: (error) => {
        this.toastr.error(this.checkIsErrorMessageValid(error));
      }
    })
  }

  getCurrentSegment(segment_id: string | number): void {
    this.loader = true;    
    this.contentMapper.get(`${segment_endpoint.segment}/${segment_id}`).subscribe({
      next: (response: any) => {
        const { segment } = response.results;
        const initialStatus = segment.hasFirstApproval ? 'active' : 'pending';

        const statusArrays = this.buildStatusArrays(segment, initialStatus);
        this.commonService.updateShareContentPoolStatus(statusArrays);
        
        this.segmentStatusModalConfig = {
          isOpen: true,
          type: 'segment-review',
          segmentData: segment
        };
        
        this.loader = false;
      },
      error: (error: any) => {
        this.loader = false;
        this.toastr.error(this.checkIsErrorMessageValid(error));
      }
    });
  }

  private mapToStatusItem(status: 'active' | 'pending' | 'deleted') {
    return (item: any) => ({
      id: item.id ?? item,
      name: item.name ?? item,
      status
    });
  }

  private safeMapArray(arr: any[] | undefined, status: 'active' | 'pending' | 'deleted'): any[] {
    return arr?.length ? arr.map(this.mapToStatusItem(status)) : [];
  }

  private buildStatusArrays(segment: any, initialStatus: 'active' | 'pending') {
    const contentPoolStatus = [
      ...this.safeMapArray(segment.activeContentIds, 'active'),
      ...this.safeMapArray(segment.addedContentIds, 'pending'),
      ...this.safeMapArray(segment.removedContentIds, 'deleted')
    ];

    const ttdSegmentStatus = [
      ...this.safeMapArray(segment.ttd_segments, initialStatus),
      ...this.safeMapArray(segment.added_ttd_segments, 'pending'),
      ...this.safeMapArray(segment.removed_ttd_segments, 'deleted')
    ];

    const partnerIdStatus = [
      ...this.safeMapArray(segment.partner_ids, initialStatus),
      ...this.safeMapArray(segment.updated_partner_ids, 'pending'),
      ...this.safeMapArray(segment.removed_partner_ids, 'deleted')
    ];

    const advertiserIdsStatus = [
      ...this.safeMapArray(segment.advertiser_ids, initialStatus),
      ...this.safeMapArray(segment.updated_advertiser_ids, 'pending'),
      ...this.safeMapArray(segment.removed_advertiser_ids, 'deleted')
    ];

    const providerElementIdStatus = [
      ...this.safeMapArray(segment.provider_element_id, initialStatus),
      ...this.safeMapArray(segment.providupdated_provider_element_ider_element_id, initialStatus),
    ];


    return {
      contentPoolStatus,
      ttdSegmentStatus,
      partnerIdStatus,
      advertiserIdsStatus,
      providerElementIdStatus
    };
  }

}
